/** Phân quyền — người dùng nội bộ */
export const USER_PERMISSION_CODES = {
  WEB_BH_USER_LIST: 'WEB_BH_USER_LIST',
  WEB_BH_USER_DETAIL: 'WEB_BH_USER_DETAIL',
  WEB_BH_USER_ADD: 'WEB_BH_USER_ADD',
  WEB_BH_USER_EDIT: 'WEB_BH_USER_EDIT',
  WEB_BH_USER_EXPORT: 'WEB_BH_USER_EXPORT',
} as const

export type UserPermissionCode = (typeof USER_PERMISSION_CODES)[keyof typeof USER_PERMISSION_CODES]

export const userPermissionCodeValues = Object.values(USER_PERMISSION_CODES)

export const USER_READ_PERMISSIONS = [
  USER_PERMISSION_CODES.WEB_BH_USER_LIST,
  USER_PERMISSION_CODES.WEB_BH_USER_DETAIL,
] as const

export const USER_MUTATE_PERMISSIONS = [
  USER_PERMISSION_CODES.WEB_BH_USER_ADD,
  USER_PERMISSION_CODES.WEB_BH_USER_EDIT,
  USER_PERMISSION_CODES.WEB_BH_USER_EXPORT,
] as const
